export const loadGraphicSvgErrors = (
    t: (key: string) => string
): {
    [key: string]: string;
} => {
    return {
        graphicNotFound: t('Graphic not found.'),
        graphicNotSvg: t('Graphic is not SVG.'),
        graphicNotCustomers: t('Graphic does not belong to this customer.'),
    };
};
